module.exports = __webpack_public_path__ + "static/homepage-hero-1920-0ebc6e2db9bd0c188de7a372be00b7da.jpg";